import { Component, inject } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

import * as _ from 'lodash';

import { CompanyApiService } from 'src/app/api/services/company-api.service';
import { CompanyTreeCacheService } from 'src/app/app-common/services/company-tree-cache.service';
import { CompanyStateService } from 'src/app/auth/services/company-state.service';

interface CompanyNotice {
  title: string;
  message: string;
}

@Component({
  selector: 'move-company',
  templateUrl: './move-company.component.html',
  styleUrls: ['./move-company.component.scss'],
  standalone: false,
})
export class MoveCompanyComponent {
  public loading = false;
  public company: any = {};
  public errors: CompanyNotice[] = [];
  public messages: CompanyNotice[] = [];
  public moveSuccess = false;

  public dismissButtonText = 'Cancel';

  private readonly companyTreeCache = inject(CompanyTreeCacheService);

  selectedCompany = this.companyStateService.getCopyOfSelectedCompany();

  constructor(
    public dialogRef: MatDialogRef<MoveCompanyComponent>,
    private companyStateService: CompanyStateService,
    private companyApiService: CompanyApiService,
  ) {}

  closeModal() {
    this.dialogRef.close(true);
  }

  moveCompany() {
    this.messages = [];
    this.loading = true;
    return this.companyApiService
      .moveCompany(
        this.company.authKey,
        this.companyStateService.getSelectedCompanyId(),
      )
      .then(() => {
        this.companyTreeCache.invalidate();
        this.messages.push({
          title: 'Company moved.',
          message: 'The company has been moved under your company.',
        });
        this.dismissButtonText = 'Close';
        this.moveSuccess = true;
      })
      .catch((err) => {
        this.errors.push({
          title: 'Failed to move company.',
          message: this.noticeDetail(err),
        });
      })
      .finally(() => {
        this.loading = false;
      });
  }

  getCompany() {
    this.errors = [];
    this.messages = [];
    this.loading = true;
    return this.companyApiService
      .lookupCompany(this.company.authKey)
      .then((resp) => {
        _.extend(this.company, resp);
      })
      .catch((resp) => {
        this.errors.push({
          title: 'Failed to retrieve company.',
          message: this.noticeDetail(resp),
        });
      })
      .finally(() => {
        this.loading = false;
      });
  }

  private noticeDetail(error: { message?: unknown }): string {
    return typeof error?.message === 'string'
      ? error.message
      : JSON.stringify(error);
  }
}
